module.exports = ".hide {\r\n    display: none;\r\n  }"